/**
 * The virtual account P&L's month range (TMMAPP-0113 4e, Operator 2026-10-07): the download range's
 * presets (`downloadRange.ts`, C2), in months — the contract's `from` / `to` are `YYYY-MM` — so the
 * view and the downloads share one range vocabulary. Year to date is the default: the server's own
 * window, so it sends no months and leaves the URL clean.
 */

import { presetRange, RANGE_PRESETS, type RangePreset } from './downloadRange';

/** The downloads' presets, in their order: one range vocabulary (4e). */
export const PNL_PRESETS = RANGE_PRESETS;
export type PnlPreset = RangePreset;

export interface PnlMonths {
  from: string;
  to: string;
}

const MONTH = /^\d{4}-(0[1-9]|1[0-2])$/;

export const isMonth = (value: string): boolean => MONTH.test(value);

/** A preset's months from the civil `today` (the viewer's zone). */
export function presetMonths(preset: PnlPreset, today: string): PnlMonths {
  const [from, to] = presetRange(preset, today);
  return { from: from.slice(0, 7), to: to.slice(0, 7) };
}

/** The preset a served range is, or `null` (a custom range). No months = the default, Year to date. */
export function presetOf(months: { from: string; to: string }, today: string): PnlPreset | null {
  if (months.from === '' && months.to === '') return 'ytd';
  return (
    PNL_PRESETS.find((preset) => {
      const range = presetMonths(preset, today);
      return range.from === months.from && range.to === months.to;
    }) ?? null
  );
}

/** A custom range is bad when both months are set and the start is after the end. */
export function isBadRange(from: string, to: string): boolean {
  return isMonth(from) && isMonth(to) && from > to;
}
